import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { useErrorContext } from "@magento/peregrine/lib/context/unhandledErrors";
import App from "./app";
import { useErrorBoundary } from "@magento/venia-ui/lib/components/App/useErrorBoundary";
var AppContainer = () => {
  var ErrorBoundary = useErrorBoundary(App);
  var [unhandledErrors, errorApi] = useErrorContext();
  return /*#__PURE__*/React.createElement(ErrorBoundary, _extends({
    unhandledErrors: unhandledErrors
  }, errorApi));
};
export default AppContainer;